module.exports = __webpack_public_path__ + "static/media/download-underline.895df729.svg";